import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { FontIcon } from 'react-md';

import { logoutRequest } from './../../../store/reducers/user';
import NavLink from './../../atoms/navLink';
import { baseUrl } from './../../../services/endpoints';

const NavList = props => {
  const showAudit = baseUrl.includes('bibloredapp') || baseUrl.includes('bkappustabog');
  const { onNavigate } = props;
  const userRole = props.user ? props.user.role : null;

  const [nav, setNav] = useState([
    { label: 'Inicio', icon: 'home', to: '/', exact: true },
    ...(['root', 'admin'].includes(userRole)
      ? [{ label: 'Usuarios', icon: 'people_outline', to: '/users' }]
      : []),
    { label: 'Reportes', icon: 'insert_chart_outlined', to: '/reports' },
    // Ocultado temporalmente: la sección "Configuración" aún no tiene un propósito
    // { label: 'Configuración', icon: 'settings', to: '/settings' },
    ...(showAudit
      ? [{ label: 'Auditoria', icon: 'verified_user', to: '/audit' }]
      : []),
  ]);

  useEffect(() => {
    if (!Array.isArray(props.appType)) return;
    let itemsAdded = [...nav];

    props.appType.forEach(item => {
      switch (item) {
        case 'rooms':
          if (!itemsAdded.some(i => i.label === 'Reservas')) {
            itemsAdded = itemsAdded.concat([
              { label: 'Reservas', icon: 'event_note', to: '/reservation', exact: true },
            ]);
          }
          itemsAdded = itemsAdded.concat([
            { label: 'Salas', icon: 'meeting_room', to: '/rooms', exact: true },
            { label: 'Horarios Salas', icon: 'schedule', to: '/rooms/schedule', exact: true },
          ]);
          break;

        case 'tutors':
          if (!itemsAdded.some(i => i.label === 'Reservas')) {
            itemsAdded = itemsAdded.concat([
              { label: 'Reservas', icon: 'event_note', to: '/reservation', exact: true },
            ]);
          }
          itemsAdded = itemsAdded.concat([
            { label: 'Referencistas', icon: 'school', to: '/tutors', exact: true },
            { label: 'Horarios Referencistas', icon: 'schedule', to: '/tutors/schedule', exact: true },
          ]);
          break;

        default:
          break;
      }
    });

    setNav(itemsAdded);
  }, [props.appType]);

  const doLogout = () => {
    return props.logoutRequest();
  };

  return (
    <nav style={styles.nav}>
      <div style={styles.mainLinks}>
        {nav.map((item, index) => (
          <NavLink
            key={index}
            label={item.label}
            icon={item.icon}
            to={item.to}
            exact={item.exact}
            onClick={onNavigate}
          />
        ))}
      </div>
      <div style={styles.divider} />
      <div
        style={styles.externalLinkItem}
        onClick={() => window.open('https://bibliotecas.geniatecnologia.co/', '_blank')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && window.open('https://bibliotecas.geniatecnologia.co/', '_blank')}
      >
        <i className="fas fa-book-reader" style={{ fontSize: 16, color: '#666', marginRight: 12 }} />
        <span style={{ fontSize: 14, color: '#555', flex: 1 }}>Bibliotecas</span>
        <i className="fas fa-external-link-alt" style={{ fontSize: 12, color: '#999' }} />
      </div>
      <div style={styles.divider} />
      <div style={styles.bottomLinks}>
        <NavLink
          key={999}
          label="Mi perfil"
          icon="account_circle"
          to="/profile"
          onClick={onNavigate}
        />
        <div
          style={styles.logoutItem}
          onClick={() => doLogout()}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && doLogout()}
        >
          <FontIcon style={{ fontSize: 20, color: '#666', marginRight: 12 }}>
            exit_to_app
          </FontIcon>
          <span style={{ fontSize: 14, color: '#555' }}>Cerrar Sesión</span>
        </div>
      </div>
    </nav>
  );
};

const styles = {
  nav: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: '16px 8px',
    position: 'sticky',
    top: '5rem',
    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
  },
  mainLinks: {
    marginBottom: 8,
  },
  divider: {
    height: 1,
    backgroundColor: '#eee',
    margin: '8px 16px',
  },
  bottomLinks: {
    marginTop: 8,
  },
  logoutItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    borderRadius: 8,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  externalLinkItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    borderRadius: 8,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
};

const mapStateToProps = state => ({
  appType: state.user.appType,
  user: state.user.user,
});

const mapDispatchToProps = dispatch => ({
  logoutRequest: () => dispatch(logoutRequest())
});

export default connect(mapStateToProps, mapDispatchToProps)(NavList);
